import { telHref } from './contactMethods'

// THE one place the call-channel set lives (CF-1 P4). Swapping in a virtual phone bank is one
// edit to `useCallChannels` plus one `callHref` arm; no call site changes.
export type CallChannel = 'PersonalPhone' // future: | 'Vpb'

export interface CallChannelSet {
  channels: readonly CallChannel[]
  defaultChannel: CallChannel
}

const CHANNELS: CallChannelSet = { channels: ['PersonalPhone'], defaultChannel: 'PersonalPhone' }

export function useCallChannels(): CallChannelSet {
  return CHANNELS
}

export function callChannelLabel(c: CallChannel): string {
  switch (c) {
    case 'PersonalPhone': return 'Use my own phone'
  }
}

export function callHref(c: CallChannel, phone: string): string | null {
  switch (c) {
    case 'PersonalPhone': return telHref(phone)
  }
}
